import { jsx } from 'react/jsx-runtime';
import { memo } from 'react';
import { LoaderGifBitiba, LoaderGif } from '@zooplus/ui-components';
import { BITIBA_REALM } from '../../utils/constants.js';
import { CURRENT_SITE_REALM } from '../../utils/site-utils.js';
import styles from './loader.module.scss.js';

// eslint-disable-next-line react/display-name
const Loader = memo(() => {
    return (jsx("div", { className: styles.loaderWrapper, "data-testid": "loader", children: CURRENT_SITE_REALM === BITIBA_REALM ? jsx(LoaderGifBitiba, {}) : jsx(LoaderGif, {}) }));
});

export { Loader };
//# sourceMappingURL=loader.js.map
